import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, PhoneNumberObj } from '../../types';

const initialState: AuthState = {
  phoneNumberObj: {
    countryCode: 'DE',
    callingCode: '49',
    number: '',
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setPhoneNumberObj: (state, action: PayloadAction<PhoneNumberObj>) => {
      state.phoneNumberObj = action.payload;
    },
    updatePhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumberObj.number = action.payload;
    },
    updateCountryCode: (
      state,
      action: PayloadAction<{ countryCode: string; callingCode: string }>
    ) => {
      state.phoneNumberObj.countryCode = action.payload.countryCode;
      state.phoneNumberObj.callingCode = action.payload.callingCode;
    },
    resetPhoneNumber: (state) => {
      state.phoneNumberObj = initialState.phoneNumberObj;
    },
  },
});

export const { setPhoneNumberObj, updatePhoneNumber, updateCountryCode, resetPhoneNumber } =
  authSlice.actions;
export default authSlice.reducer;
